<button
  *hasPermission="permissions()"
  data-testid="create-entity-button"
  mat-flat-button
  [color]="color()"
  (click)="onCreateClick()"
>
  <div class="flex items-center gap-2">
    <app-icon src="/icons/plus.svg" />
    {{ labelKey() | translate }}
  </div>
</button>
